import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { API_INTERFACE } from '../../../services/constants'

const providerDomainApi = axios.create({ baseURL: process.env.CAREPOINT_URL || process.env.REACT_APP_CAREPOINT_URL });

const networksToNames = (networks: any[]): string[] =>
  networks.map((network: any) =>
    network.networkName
      ? network.networkName.toString().trim().toLowerCase()
      : network.trim().toLowerCase()
  )

const flatResults = async (promises: Promise<any>[]) => {
  const results = await Promise.all(promises)

  return results.flat()
}

export const fetchCarepointFacilities = createAsyncThunk(
  'providers/fetchCarepointFacilities',
  async ({ zipcode, networks, specialties }: any) => {
    const params = {
      zipCode: zipcode,
      networks: networksToNames(networks).join(','),
      virtualOptions: 'only,y,n',
      specialties
    }
    let facilitiesData = []
    const response = await providerDomainApi.get(API_INTERFACE.FETCH_OPENSEARCH_FACILITIES_BY_ZIPCODE, { params })
    if (response && response.data && response.data.data && response.data.data.length > 0) {
      facilitiesData = response.data.data
    }

    return facilitiesData
  }
)

export const fetchPractitionersAndCoordinates = createAsyncThunk(
  'providers/fetchPractitioners',
  async ({ name, networks, specialties, zipcode }: any) => {
    const params = {
      name,
      zipCode: zipcode,
      networks: networksToNames(networks).join(','),
      specialties
    };
    let providersData = []
    const response = await providerDomainApi.get(API_INTERFACE.FETCH_OPENSEARCH_PRACTICES_BY_ZIPCODE, { params })
    if (response && response.data && response.data.data && response.data.data.length > 0) {
      providersData = response.data.data
    }

    return providersData
  }
)

export const fetchPractitionersByNpi = createAsyncThunk(
  'providers/fetchPractitionersByNpi',
  async ({ npi, networks }: any) => {
    const params = {
      npi,
      networks: networksToNames(networks).join(','),
    };

    let providersData = []
    const response = await providerDomainApi.get(API_INTERFACE.FETCH_OPENSEARCH_PROVIDERS, { params })
    if (response && response.data && response.data.data && response.data.data.length > 0) {
      providersData = response.data.data
    }

    return providersData
  }
)
